// source: stailer/externaladminrpc/pick_pack/pick_pack_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pick_pack.PickPackOption', null, global);
goog.exportSymbol('proto.pick_pack.PickingType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pick_pack.PickPackOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pick_pack.PickPackOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pick_pack.PickPackOption.displayName = 'proto.pick_pack.PickPackOption';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pick_pack.PickPackOption.prototype.toObject = function(opt_includeInstance) {
  return proto.pick_pack.PickPackOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pick_pack.PickPackOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pick_pack.PickPackOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    pickingType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PickPackOption as accepted by the `fromObject` method.
 * @record
 */
proto.pick_pack.PickPackOption.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.pickingType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.pick_pack.PickPackOption.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.pick_pack.PickPackOption}
 */
proto.pick_pack.PickPackOption.fromObject = function(obj) {
  var msg = new proto.pick_pack.PickPackOption();
  obj.pickingType != null && jspb.Message.setField(msg, 1, obj.pickingType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pick_pack.PickPackOption}
 */
proto.pick_pack.PickPackOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pick_pack.PickPackOption;
  return proto.pick_pack.PickPackOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pick_pack.PickPackOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pick_pack.PickPackOption}
 */
proto.pick_pack.PickPackOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pick_pack.PickingType} */ (reader.readEnum());
      msg.setPickingType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pick_pack.PickPackOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pick_pack.PickPackOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pick_pack.PickPackOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pick_pack.PickPackOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPickingType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional PickingType picking_type = 1;
 * @return {!proto.pick_pack.PickingType}
 */
proto.pick_pack.PickPackOption.prototype.getPickingType = function() {
  return /** @type {!proto.pick_pack.PickingType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pick_pack.PickingType} value
 * @return {!proto.pick_pack.PickPackOption} returns this
 */
proto.pick_pack.PickPackOption.prototype.setPickingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.pick_pack.PickingType = {
  TOTAL: 0,
  SINGLE_BASKET: 1
};

goog.object.extend(exports, proto.pick_pack);
